import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import '../styles/DemoSection.css';

const DemoSection = ({ standalone = false }) => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayDemo = () => {
    setIsPlaying(true);
  };

  return (
    <section
      id="demo"
      className={`demo-section section section-dark section-page${standalone ? ' demo-section--standalone' : ''}`}
      ref={ref}
    >
      <div className="container">
        <motion.div 
          className="section-header text-center"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2>Entrená a tu <span className="text-gradient">propio empleado</span></h2>
          <p>
            Descubre lo sencillo que es entrenar un agente de IA 
            con nuestra demo interactiva. Prueba el proceso paso a paso.
          </p>
        </motion.div>

        <motion.div 
          className="demo-container"
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <div className="demo-wrapper">
            {!isPlaying ? (
              <div className="demo-preview">
                <div className="demo-background">
                  <div className="demo-pattern"></div>
                  <div className="demo-glow"></div>
                </div>
                
                <motion.button
                  className="play-button"
                  onClick={handlePlayDemo}
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                  initial={{ scale: 0 }}
                  animate={inView ? { scale: 1 } : {}}
                  transition={{ duration: 0.6, delay: 0.8 }}
                >
                  <motion.div 
                    className="play-icon"
                    animate={{ scale: [1, 1.1, 1] }}
                    transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                  >
                    ▶
                  </motion.div>
                </motion.button>

                <div className="demo-info-centered">
                  <h3>Demo Interactiva en Vivo</h3>
                  <p>Aprende lo fácil que es entrenar tu agente de IA</p>
                </div>
              </div>
            ) : (
              <motion.div 
                className="demo-iframe-container"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6 }}
              >
                <iframe
                  src="https://runamatic-web-demo.vercel.app/"
                  title="Runamatic Demo"
                  className="demo-iframe"
                  frameBorder="0"
                  allowFullScreen
                ></iframe>
                
                <motion.button
                  className="close-demo"
                  onClick={() => setIsPlaying(false)}
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                >
                  ✕
                </motion.button>
              </motion.div>
            )}
          </div>
        </motion.div>

        <motion.div 
          className="demo-actions"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <div className="actions-content">
            <h3>¿Te gustó lo que viste?</h3>
            <p>Comienza tu prueba gratuita ahora y experimenta el poder de Runamatic en tu propio negocio.</p>
            
            <div className="actions-buttons">
              <motion.a
                href="https://app.runamatic.io/en/login"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Comenzar Prueba Gratuita
              </motion.a>
              
              <motion.a
                href="https://wa.me/5491123428342?text=Hola%2C%20quiero%20mas%20informaci%C3%B3n%20sobre%20Runamatic"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-outline"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Solicitar Demo Personalizada
              </motion.a>
            </div>
            
            <div className="demo-stats">
              <div className="stat">
                <div className="stat-number">15 min</div>
                <div className="stat-label">Setup Inicial</div>
              </div>
              <div className="stat">
                <div className="stat-number">100%</div>
                <div className="stat-label">Más Tiempo</div>
              </div>
              <div className="stat">
                <div className="stat-number">24/7</div>
                <div className="stat-label">Soporte Incluido</div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default DemoSection; 